import {ISolicitacaoTipoForm} from "@models/solicitacoes/solicitacoes.ts";
import {Box, Checkbox, FormControlLabel, TextField, Tooltip} from "@mui/material";
import {DatePicker} from "@mui/x-date-pickers";
import React from "react";

interface FormEntryProps {
	form: ISolicitacaoTipoForm,
	captureValue?: (value: string | number | boolean | Date) => void
	defaultValue?: string | number | boolean | Date
}

/**
 * @deprecated
 * @param props
 * @see InputEntry
 */
export const FormEntry: React.FC<FormEntryProps> = (props) => {
	return (
		<Tooltip title={props.form.descricao ?? ''}>
			<Box>
				{props.form.tipoPrimitivo == 'String' && <TextForm {...props}/> ||
					props.form.tipoPrimitivo == 'Bool' &&
                    <BooleanForm {...props}/> ||
					props.form.tipoPrimitivo == 'Date' && <DateForm {...props}/> ||
					(props.form.tipoPrimitivo == 'Float' || props.form.tipoPrimitivo == 'Percent' || props.form.tipoPrimitivo == 'NumberOrPercent') &&
                    <NumberForm {...props}/>}
			</Box>
		</Tooltip>);
};

const TextForm = ({form, captureValue, defaultValue}: FormEntryProps) => {
	return (
		<TextField fullWidth
		           label={form.nome}
		           required={form.obrigatorio}
		           variant={'filled'}
		           onChange={(c) => captureValue && captureValue(c.target.value)}
		           value={defaultValue}
		/>
	);
};

const BooleanForm = ({form, captureValue, defaultValue}: FormEntryProps) => {
	let v = false;
	
	if (defaultValue === true || defaultValue === 'true') {
		v = true;
	}
	
	return (
		<FormControlLabel control={<Checkbox/>}
		                  label={form.nome}
		                  required={form.obrigatorio}
		                  value={form.id}
		                  checked={v}
		                  onChange={(_c, v) => captureValue && captureValue(v)}
		/>
	);
};

const DateForm = ({form}: FormEntryProps) => {
	return (
		<DatePicker label={form.nome} sx={{width: '100%'}} slotProps={{
			textField: {variant: 'filled'},
		}}/>
	);
};

const NumberForm = ({form, defaultValue, captureValue}: FormEntryProps) => {
	return (
		<TextField label={form.nome}
		           type={'number'}
		           fullWidth
		           variant={'filled'}
		           value={defaultValue}
		           onChange={(c) => {
			           if (captureValue) {
				           const value = c.target.value;
				           captureValue(value === '' ? 0 : Number(value));
			           }
		           }}
		/>
	);
};

